module.exports = __webpack_public_path__ + "static/media/roadmap.d5fbaa17.png";